const postUserImageResponse = (data) => ({
  imagePath: data?.data?.imagePath,
  key: data?.data?.key,
});

export default postUserImageResponse;
